import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from './service/authentication.service';
import { CanActivateWithRedirect } from './can-activate-with-redirect.interface';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateWithRedirect {
	constructor(private authService: AuthenticationService) {}

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		if (this.authService.isAuthenticated()) {
			return true;
		}
		// Set redirectUrl which is recovered after login
		this.authService.redirectUrl = state.url;
		return false;
	}

	redirectRoute(): string | undefined | null {
		return undefined; // Will redirect to the container app's fallback
	}
}
